import { render, staticRenderFns } from "./BillingTable.vue?vue&type=template&id=60b7e7dc&scoped=true"
import script from "./BillingTable.ts?vue&type=script&lang=ts&external"
export * from "./BillingTable.ts?vue&type=script&lang=ts&external"
import style0 from "./BillingTable.vue?vue&type=style&index=0&id=60b7e7dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b7e7dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b7e7dc')) {
      api.createRecord('60b7e7dc', component.options)
    } else {
      api.reload('60b7e7dc', component.options)
    }
    module.hot.accept("./BillingTable.vue?vue&type=template&id=60b7e7dc&scoped=true", function () {
      api.rerender('60b7e7dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/History/components/BillingTable/BillingTable.vue"
export default component.exports